// extracted by mini-css-extract-plugin
module.exports = {"agreement":"msa_agreement__0FZ6Y"};